'use strict';

exports.__esModule = true;
exports.get = get;

var _apiClient = require('../network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  SLUGS: '/slugs'

  /**
   * Wrapper for `/slugs` API endpoint
   */

};var slugs = {
  get: get
};

exports.default = slugs;

/**
 * Get slug
 * @returns {promise} containing slug
 */

function get(attrs) {
  var slug = attrs.slug;

  return _apiClient2.default.get({ route: API.SLUGS + '/' + slug });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/slugs/slugs.js
// module id = 1189
// module chunks = 0